import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubscriptionForHardwareOffering } from '@app/sales/models/accessory.model';
import { PhoneNumberOption } from '@app/sales/modules/accessories/models/accessory-options.model';
import { VoiceProduct } from '@app/shared/models/voice-product.model';
import { HardwareVoiceProductUpgradeComponent } from '@app/shared/components/hardware-voice-product-upgrade/hardware-voice-product-upgrade.component';
import { MatTooltip } from '@angular/material/tooltip';
import { RadioButtonListItemComponent } from '@app/shared/components/atoms/radio-button-list/radio-button-list-item/radio-button-list-item.component';
import { RadioButtonListComponent } from '@app/shared/components/atoms/radio-button-list/radio-button-list.component';
import { MatRadioGroup } from '@angular/material/radio';

@Component({
  selector: 'app-phone-number-options',
  templateUrl: './phone-number-options.component.html',
  styleUrl: './phone-number-options.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatRadioGroup,
    RadioButtonListComponent,
    RadioButtonListItemComponent,
    MatTooltip,
    HardwareVoiceProductUpgradeComponent,
  ],
})
export class PhoneNumberOptionsComponent {
  @Input({ required: true }) form: FormGroup;
  @Input({ required: true }) selectedSubscription: SubscriptionForHardwareOffering;
  @Input({ required: true }) existingVoiceProducts: VoiceProduct[];

  PhoneNumberOption = PhoneNumberOption;

  get voiceProductsAvailableForUpgrade(): VoiceProduct[] {
    return this.existingVoiceProducts?.filter(p => !p.accessoryProductId) || [];
  }
}
